module.exports = __webpack_public_path__ + "img/icos3.fc9ec7a3.svg";